import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeToken } from "../App";
import { Button } from "../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../components/ui/alert-dialog";
import { LogOut, Database, Settings, Users } from "lucide-react";

export default function Sidebar({ activeMenu }) {
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    navigate("/login");
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-56 bg-[#0A0A0A] border-r border-[#222222] flex-col min-h-screen fixed left-0 top-0 z-40">
        <nav className="flex-1 p-4 pt-6">
          <ul className="space-y-2">
            <li>
              <button
                data-testid="menu-profiles"
                onClick={() => navigate("/perfis")}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-sm transition-colors font-body text-sm ${
                  activeMenu === "profiles"
                    ? "bg-[#00FF94] text-black font-bold"
                    : "text-[#888888] hover:bg-[#111111] hover:text-[#EDEDED]"
                }`}
              >
                <Users className="w-5 h-5" />
                Perfis
              </button>
            </li>
            <li>
              <button
                data-testid="menu-cookies"
                onClick={() => navigate("/cookies")}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-sm transition-colors font-body text-sm ${
                  activeMenu === "cookies"
                    ? "bg-[#00FF94] text-black font-bold"
                    : "text-[#888888] hover:bg-[#111111] hover:text-[#EDEDED]"
                }`}
              >
                <Database className="w-5 h-5" />
                Cookies
              </button>
            </li>
            <li>
              <button
                data-testid="menu-api"
                onClick={() => navigate("/documentacao")}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-sm transition-colors font-body text-sm ${
                  activeMenu === "api"
                    ? "bg-[#00FF94] text-black font-bold"
                    : "text-[#888888] hover:bg-[#111111] hover:text-[#EDEDED]"
                }`}
              >
                <Settings className="w-5 h-5" />
                API Info
              </button>
            </li>
          </ul>
        </nav>

        <div className="p-4 border-t border-[#222222]">
          <Button
            data-testid="logout-button-desktop"
            onClick={() => setLogoutDialogOpen(true)}
            variant="ghost"
            className="w-full text-[#888888] hover:text-[#FF3B30] hover:bg-[#111111] rounded-sm font-body justify-start"
          >
            <LogOut className="w-5 h-5 mr-3" />
            Sair
          </Button>
        </div>
      </aside>

      {/* Mobile Bottom Navigation */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-[#0A0A0A] border-t border-[#222222] z-50">
        <div className="flex items-center justify-around h-16">
          <button
            data-testid="menu-profiles-mobile"
            onClick={() => navigate("/perfis")}
            className={`flex flex-col items-center justify-center gap-1 px-4 py-2 flex-1 transition-colors ${
              activeMenu === "profiles"
                ? "text-[#00FF94]"
                : "text-[#888888]"
            }`}
          >
            <Users className="w-6 h-6" />
            <span className="text-[10px] font-body">Perfis</span>
          </button>
          <button
            data-testid="menu-cookies-mobile"
            onClick={() => navigate("/cookies")}
            className={`flex flex-col items-center justify-center gap-1 px-4 py-2 flex-1 transition-colors ${
              activeMenu === "cookies"
                ? "text-[#00FF94]"
                : "text-[#888888]"
            }`}
          >
            <Database className="w-6 h-6" />
            <span className="text-[10px] font-body">Cookies</span>
          </button>
          <button
            data-testid="menu-api-mobile"
            onClick={() => navigate("/documentacao")}
            className={`flex flex-col items-center justify-center gap-1 px-4 py-2 flex-1 transition-colors ${
              activeMenu === "api"
                ? "text-[#00FF94]"
                : "text-[#888888]"
            }`}
          >
            <Settings className="w-6 h-6" />
            <span className="text-[10px] font-body">API</span>
          </button>
        </div>
      </nav>

      {/* Logout Confirmation Dialog */}
      <AlertDialog open={logoutDialogOpen} onOpenChange={setLogoutDialogOpen}>
        <AlertDialogContent className="bg-[#0A0A0A] border-[#222222] max-w-[90vw] md:max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-[#EDEDED] font-heading">
              Sair da Conta
            </AlertDialogTitle>
            <AlertDialogDescription className="text-[#888888] font-body">
              Tem certeza que deseja sair da sua conta? Você precisará fazer login novamente para acessar o painel.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-[#111111] border-[#333333] text-[#EDEDED] hover:bg-[#222222] rounded-sm font-body">
              Cancelar
            </AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-logout-button"
              onClick={handleLogout}
              className="bg-[#FF3B30] text-white hover:bg-[#D63025] rounded-sm font-body"
            >
              Sair
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
